import { StaffAvailabilityHub } from "@/components/staff/StaffAvailabilityHub";

export default function AdminStaffAvailability() {
  return <StaffAvailabilityHub />;
}
